import "./styles.css";
import Footer from "./footer.js";
import "./slick-variable.css";
import "./slick-theme.min.css";
import "./slick.min.css";
import { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import logo from "./images/teilor-logo.svg";
import HomeImg from "./images/homeimg.jpg";

// ==========BRIDAL MAIN COMPONENT=============
import Urban from "./urban/urban";

export default function App() {
  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();
  let appDelay = useRef(null);
  let appBody = useRef(null);
  useEffect(() => {
    // gsap.set(appDelay, { opacity: 0});
    gsap.to(appBody, { overflowY: "hidden" });

    // gsap.to(appDelay, {
    //   display: "unset",
    //   opacity: 1,
    //   duration: 1.4,
    //   delay: 5.5
    // });

    gsap.to(appBody, {
      overflowY: "visible",
      duration: 1.4,
      delay: 5.5
    });
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
        scrollToTop();
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
          scrollToTop();

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          scrollToTop();

          // Handle back event
        }
      }
    });
  }, [locationKeys, history]);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "PageView"
  });

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  useEffect(() => {
    scrollToTop();
  });
  return (
    <div className="mainAppBody" ref={(el) => (appBody = el)}>
      <div className="faded" ref={(el) => (appDelay = el)}>
        <Urban />

        <Footer />
      </div>
    </div>
  );
}
